// reviews/{reviewId} — see functions/index.js submitReview.

const ReviewerRole = Object.freeze({
  HOST: 'host',
  GUEST: 'guest',
});

// Fields: reviewId, bookingId, mealId, hostId, guestId, reviewerRole,
// culinaryRating, serviceRating, cleanlinessRating, overallRating,
// reviewText, photos, isVisible, createdAt, updatedAt.
//
// ratingsCounted (bool, absent until first counted): set by
// functions/ratings.js once this review's delta has been applied to the
// reviewed user's rating aggregate, so the trigger stays idempotent.

const otherRole = (reviewerRole) =>
  reviewerRole === ReviewerRole.HOST ? ReviewerRole.GUEST : ReviewerRole.HOST;

const calculateOverallRating = ({ culinaryRating, serviceRating, cleanlinessRating }) =>
  parseFloat(((culinaryRating + serviceRating + cleanlinessRating) / 3).toFixed(2));

module.exports = { ReviewerRole, otherRole, calculateOverallRating };
